import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
import type {GetProductsParams, ProductCatalogProducts} from '~/services/productCatalog/types';

export default class ProductCatalogService<P extends ProductDetail = ProductDetail> {
	static emptyResponse<P extends ProductDetail>(): ProductCatalogProducts<P> {
		return {products: [], paginationShowMore: false};
	}

	get name(): string {
		return 'ProductCatalogService';
	}

	getProducts(_params: GetProductsParams): Promise<ProductCatalogProducts<P>> {
		return Promise.resolve(ProductCatalogService.emptyResponse());
	}

	dispose(): void {
	}

	protected fillDefaultParams(params: GetProductsParams): Required<GetProductsParams> {
		return {
			offset: 0,
			category: '',
			countries: [],
			brands: [],
			...params,
		};
	}
}
